<template>
    <a-card>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            @change="onTableChange">
            <template #level="{text}">
                <a-tag><dict-render :dict-obj="dictObjs['policy_level']" :text="text"></dict-render></a-tag>
            </template>
<!--            <template #title="{record}">-->
<!--                {{record.id}}-->
<!--                <a @click="onDetail(record)"></a>-->
<!--            </template>-->
            <template #ifPublish="{text}">
                <a-tag><dict-render :dict-obj="dictObjs['ifPublish']" :text="text" :style="dictObjs['ifPublish']?.cssClass"></dict-render></a-tag>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onDetail(record)">详情</a>
                </div>
            </template>
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
        </a-table>
    </a-card>
    <DetailDrawer ref="modal" @onCloseModel="onCloseModel" @finish="onFormEdited"/>

</template>

<script>
import {policyApi} from "@/api/innovationService";
import {dictMixin} from "@/mixins";
import {defaultDateCustomRender} from "@/utils/customRender";
import DictRender from "@/components/other/DictRender";
import DetailDrawer from "./components/DetailDrawer";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "政策标题", dataIndex: "title", key: "title",slots: {customRender: "title"}},
    {title: "政策级别", dataIndex: "level", key: "level",slots: {customRender: "level"}},
    {title: "政策来源", dataIndex: "origin", key: "origin"},
    {title: "发布时间", dataIndex: "publishTime", key: "publishTime",customRender:defaultDateCustomRender},
    {title: "发布状态", dataIndex: "ifPublish", key: "ifPublish",slots: {customRender: "ifPublish"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},

];
export default {
    name: "index",
    mixins: [dictMixin],
    components: {
        DictRender,DetailDrawer
    },
    data() {
        return {
            dictNames:'policy_level,ifPublish',
            columns,
            queryParam: {},
            listKeyField: "id",
            companyId:'',
            dataSource:[],
            companyCode:''
        }
    },
    mounted() {
        this.getlist()
        this.companyCode = this.$ls.get("companyCode")
    },
    methods: {
        onShowModal(refName, data = {}) {
            const refEle = this.$refs[refName];
            refEle.form = Object.assign({}, data);
            refEle.visible = true;
        },
        getlist(){
            this.getAction({
                url:policyApi.listRules,
                params:{
                    companyCode: this.companyCode
                }
            }).then(res=>{
                this.companyId = res.toString()
                if (this.companyId.length != 0){
                    this.getPageList(this.companyId)
                }

            })
        },
        getPageList(id){
            this.getAction({
                url:policyApi.listInfo + id
            }).then(res=>{
                console.log(res,'ssss')
                this.dataSource = res
            })
        },
        onDetail(record){
            this.getAction({
                url:policyApi.getDetail,
                params:{id:record.id}
            }).then(res=>{
                this.onShowModal("modal",res)
            })
        }
    }
}
</script>

<style scoped>

</style>
